<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Privacy Policy" />
            <PrivacyPolicy />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'PrivacyPolicyPage',
    components: {
        NavBar,
        PageTitle,
        PrivacyPolicy,
        FooterComp,
    }
}
</script>